import { Button, InputField } from "components";
import { Toggle } from "components/atoms/Toggle";
import { ChangeEvent, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import Popup from "components/molecules/Popup/Popup";
import Svg from "assets/svg";
import { schemaProps } from "../../schema";

interface AddOrEditProps {
  id?: string;
  handleClose: () => void;
  handleSubmit: (data: schemaProps) => void;
}

export const AddOrEdit = (props: AddOrEditProps) => {
  const { handleClose, handleSubmit } = props;
  const form = useFormContext<schemaProps>();
  useEffect(() => {
    return () => {
      form.reset();
    };
  }, []);
  return (
    <Popup type="modal" closeOnOutsideClick={false} onClose={handleClose}>
      <p className="w-full text-left font-bold text-sm pt-1">
        {props.id ? "Edit page intent" : "Add new page url"}
      </p>
      <form
        className="flex flex-col gap-4 w-full"
        autoComplete="off"
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        <Toggle
          name="pageCondition"
          items={[
            {
              label: "Contains",
              value: "contains",
            },
            {
              label: "Is",
              value: "is",
            },
          ]}
        />
        <Controller
          name="pageUrl"
          render={({ field }) => (
            <InputField
              type="text"
              name="Page url"
              size="tiny"
              placeholder={`Enter the url ${
                form.watch("pageCondition") === "contains"
                  ? "containing the"
                  : "exactly as the"
              } page path`}
              value={field.value}
              autoFocus={true}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                field.onChange(e.target.value)
              }
            />
          )}
        />
        <p className="w-full text-left text-sm pt-1 font-semibold">
          Select the page intent
        </p>
        <span className="w-full text-left text-xs">
          All pages default to medium. Only low and high intents need to be
          specified.
        </span>
        <Toggle
          size="sm"
          name="pageIntent"
          items={[
            {
              label: "Low",
              value: "low",
              icon: <Svg.snailWhite />,
            },
            {
              label: "Medium",
              value: "medium",
              icon: "zap",
            },
            {
              label: "High",
              value: "high",
              icon: "fire",
            },
          ]}
        />
        <div className="flex w-full justify-center">
          <div>
            <Button
              isProcessing={form.formState.isSubmitting}
              disabled={!form.formState.isValid}
              action="submit"
            >
              {" "}
              {props.id ? "Save Changes" : "Submit"}{" "}
            </Button>
          </div>
        </div>
      </form>
    </Popup>
  );
};
